import React from "react";
import Scope from "@radarly/components/navigation/navbar/scope";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";

interface NavbarScopeProps {
  onClick: () => void;
}

export function NavbarScope({ onClick }: NavbarScopeProps) {
  const workspace = useCurrentWorkspace();
  const project = useCurrentProject();
  return <Scope project={project} workspace={workspace} onClick={onClick} />;
}
